import { render } from "./Events.vue?vue&type=template&id=2559adc2"
import script from "./Events.vue?vue&type=script&lang=js"
export * from "./Events.vue?vue&type=script&lang=js"

import exportComponent from "/Users/MearnsGill/Sites/ICoTA/icota-europe.localhost/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__